import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["color"],
    _excluded2 = ["color"],
    _excluded3 = ["color"],
    _excluded4 = ["color"],
    _excluded5 = ["color"],
    _excluded6 = ["color"],
    _excluded7 = ["color"],
    _excluded8 = ["color"],
    _excluded9 = ["color"],
    _excluded10 = ["color"],
    _excluded11 = ["color"],
    _excluded12 = ["color"],
    _excluded13 = ["color"],
    _excluded14 = ["color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Icon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export * from './diet';
export var LikeIcon = function LikeIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'white' : _ref$color,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "11",
    height: "11",
    viewBox: "0 0 11 11"
  }, rest), {}, {
    color: color,
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.3197 4.21668C9.10873 3.94168 8.81337 3.71251 8.47582 3.66668H8.26485H6.32392V2.29168C6.32392 1.28334 5.56443 0.458344 4.63616 0.458344C4.46738 0.458344 4.2986 0.55001 4.25641 0.733344L2.69523 4.58334H1.68257C0.965271 4.58334 0.416748 5.17918 0.416748 5.95834V9.16668C0.416748 9.94584 0.965271 10.5417 1.68257 10.5417H7.71633C8.34924 10.5417 8.85557 10.0375 8.98215 9.39584L9.57287 5.27084C9.61506 4.90418 9.53067 4.53751 9.3197 4.21668ZM2.52645 9.62501H1.68257C1.42941 9.62501 1.26063 9.44168 1.26063 9.16668V5.95834C1.26063 5.68334 1.42941 5.50001 1.68257 5.50001H2.52645V9.62501ZM7.71633 9.62501C7.9273 9.62501 8.09607 9.48751 8.13827 9.25834L8.77118 5.08751C8.77118 4.99584 8.77118 4.85834 8.68679 4.76668C8.6024 4.67501 8.51801 4.58334 8.39143 4.58334H8.30704H5.90198C5.64882 4.58334 5.48004 4.40001 5.48004 4.12501V2.29168C5.48004 1.87918 5.22687 1.55834 4.88932 1.42084L3.37033 5.13334V9.62501H7.71633Z",
      fill: "white",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_13550_18720",
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "10",
      height: "11",
      e2eid: "Icons_index_mask",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.3197 4.21668C9.10873 3.94168 8.81337 3.71251 8.47582 3.66668H8.26485H6.32392V2.29168C6.32392 1.28334 5.56443 0.458344 4.63616 0.458344C4.46738 0.458344 4.2986 0.55001 4.25641 0.733344L2.69523 4.58334H1.68257C0.965271 4.58334 0.416748 5.17918 0.416748 5.95834V9.16668C0.416748 9.94584 0.965271 10.5417 1.68257 10.5417H7.71633C8.34924 10.5417 8.85557 10.0375 8.98215 9.39584L9.57287 5.27084C9.61506 4.90418 9.53067 4.53751 9.3197 4.21668ZM2.52645 9.62501H1.68257C1.42941 9.62501 1.26063 9.44168 1.26063 9.16668V5.95834C1.26063 5.68334 1.42941 5.50001 1.68257 5.50001H2.52645V9.62501ZM7.71633 9.62501C7.9273 9.62501 8.09607 9.48751 8.13827 9.25834L8.77118 5.08751C8.77118 4.99584 8.77118 4.85834 8.68679 4.76668C8.6024 4.67501 8.51801 4.58334 8.39143 4.58334H8.30704H5.90198C5.64882 4.58334 5.48004 4.40001 5.48004 4.12501V2.29168C5.48004 1.87918 5.22687 1.55834 4.88932 1.42084L3.37033 5.13334V9.62501H7.71633Z",
        fill: "white",
        e2eid: "Icons_index_path"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_13550_18720)",
      e2eid: "Icons_index_g",
      children: /*#__PURE__*/_jsx("rect", {
        width: "10",
        height: "11",
        fill: "white",
        e2eid: "Icons_index_rect"
      })
    })]
  }));
};
export var UnlikeIcon = function UnlikeIcon(_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? 'white' : _ref2$color,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "11",
    height: "11",
    viewBox: "0 0 11 11"
  }, rest), {}, {
    color: color,
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5688 1.79356C10.4844 1.01084 9.89361 0.458328 9.17626 0.458328H9.13406H3.26867C2.63571 0.458328 2.12935 0.964797 2.00276 1.60939L1.412 5.75323C1.3276 6.48991 1.79177 7.22659 2.46692 7.31868H2.67791H4.66117V8.69996C4.66117 9.71289 5.42072 10.5417 6.34906 10.5417C6.51784 10.5417 6.68663 10.4496 6.72883 10.2654L8.29012 6.39783H9.13406C9.85141 6.39783 10.4422 5.84531 10.5266 5.06259V5.01655V1.83961C10.5688 1.83961 10.5688 1.79356 10.5688 1.79356ZM7.61497 5.89136L6.09587 9.62081C5.7583 9.48268 5.50511 9.16038 5.50511 8.746V6.90429C5.50511 6.62804 5.33633 6.44387 5.08314 6.44387H2.67791H2.59352C2.38253 6.39783 2.21374 6.16761 2.25594 5.9374L2.8467 1.79356C2.8889 1.56335 3.05768 1.37918 3.26867 1.37918H7.61497V5.89136ZM9.17626 5.52302C9.42944 5.52302 9.68263 5.2928 9.72482 5.01655V1.88565C9.68263 1.60939 9.42944 1.37918 9.17626 1.37918H8.45891V5.52302H9.17626Z",
      fill: "white",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_13550_18752",
      maskUnits: "userSpaceOnUse",
      x: "1",
      y: "0",
      width: "10",
      height: "11",
      e2eid: "Icons_index_mask",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5688 1.79356C10.4844 1.01084 9.89361 0.458328 9.17626 0.458328H9.13406H3.26867C2.63571 0.458328 2.12935 0.964797 2.00276 1.60939L1.412 5.75323C1.3276 6.48991 1.79177 7.22659 2.46692 7.31868H2.67791H4.66117V8.69996C4.66117 9.71289 5.42072 10.5417 6.34906 10.5417C6.51784 10.5417 6.68663 10.4496 6.72883 10.2654L8.29012 6.39783H9.13406C9.85141 6.39783 10.4422 5.84531 10.5266 5.06259V5.01655V1.83961C10.5688 1.83961 10.5688 1.79356 10.5688 1.79356ZM7.61497 5.89136L6.09587 9.62081C5.7583 9.48268 5.50511 9.16038 5.50511 8.746V6.90429C5.50511 6.62804 5.33633 6.44387 5.08314 6.44387H2.67791H2.59352C2.38253 6.39783 2.21374 6.16761 2.25594 5.9374L2.8467 1.79356C2.8889 1.56335 3.05768 1.37918 3.26867 1.37918H7.61497V5.89136ZM9.17626 5.52302C9.42944 5.52302 9.68263 5.2928 9.72482 5.01655V1.88565C9.68263 1.60939 9.42944 1.37918 9.17626 1.37918H8.45891V5.52302H9.17626Z",
        fill: "white",
        e2eid: "Icons_index_path"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_13550_18752)",
      e2eid: "Icons_index_g",
      children: /*#__PURE__*/_jsx("rect", {
        x: "0.985352",
        width: "10",
        height: "11",
        fill: "white",
        e2eid: "Icons_index_rect"
      })
    })]
  }));
};
export var TopicGuideIcon = function TopicGuideIcon(_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? 'white' : _ref3$color,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "31",
    height: "32",
    viewBox: "0 0 31 32",
    fill: "none"
  }, rest), {}, {
    color: color,
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.8333 2.06323H8.39583C5.94167 2.06323 3.875 4.10407 3.875 6.52756V25.6604C3.875 28.0839 5.94167 30.1247 8.39583 30.1247H25.8333C26.6083 30.1247 27.125 29.6145 27.125 28.8492V3.33875C27.125 2.57344 26.6083 2.06323 25.8333 2.06323ZM8.39583 4.61427H24.5417V21.196H8.39583C7.75 21.196 7.10417 21.3236 6.45833 21.7063V6.52756C6.45833 5.50714 7.3625 4.61427 8.39583 4.61427ZM6.45833 25.6604C6.45833 26.6808 7.3625 27.5737 8.39583 27.5737H24.5417V23.7471H8.39583C7.3625 23.7471 6.45833 24.64 6.45833 25.6604Z",
      fill: "white",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_2687_1094",
      maskUnits: "userSpaceOnUse",
      x: "3",
      y: "2",
      width: "25",
      height: "29",
      e2eid: "Icons_index_mask",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.8333 2.06323H8.39583C5.94167 2.06323 3.875 4.10407 3.875 6.52756V25.6604C3.875 28.0839 5.94167 30.1247 8.39583 30.1247H25.8333C26.6083 30.1247 27.125 29.6145 27.125 28.8492V3.33875C27.125 2.57344 26.6083 2.06323 25.8333 2.06323ZM8.39583 4.61427H24.5417V21.196H8.39583C7.75 21.196 7.10417 21.3236 6.45833 21.7063V6.52756C6.45833 5.50714 7.3625 4.61427 8.39583 4.61427ZM6.45833 25.6604C6.45833 26.6808 7.3625 27.5737 8.39583 27.5737H24.5417V23.7471H8.39583C7.3625 23.7471 6.45833 24.64 6.45833 25.6604Z",
        fill: "white",
        e2eid: "Icons_index_path"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_2687_1094)",
      e2eid: "Icons_index_g",
      children: /*#__PURE__*/_jsx("rect", {
        y: "0.787598",
        width: "31",
        height: "30.6125",
        fill: "white",
        e2eid: "Icons_index_rect"
      })
    })]
  }));
};
export var TagIcon = function TagIcon(_ref4) {
  var _ref4$color = _ref4.color,
      color = _ref4$color === void 0 ? 'white' : _ref4$color,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, rest), {}, {
    color: color,
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.739 7.21067L9.05979 1.53143C8.92771 1.39935 8.79564 1.33331 8.59753 1.33331H1.99375C1.59752 1.33331 1.33337 1.59746 1.33337 1.99369V8.59746C1.33337 8.79558 1.39941 8.92765 1.53149 9.05973L7.21073 14.739C7.60696 15.1352 8.06922 15.3333 8.59753 15.3333C9.12583 15.3333 9.65413 15.1352 9.98432 14.739L14.739 9.98426C15.5315 9.1918 15.5315 8.00312 14.739 7.21067ZM13.8145 9.05973L9.05979 13.8144C8.79564 14.0786 8.39941 14.0786 8.13526 13.8144L2.65413 8.33331V2.65407H8.33337L13.8145 8.1352C14.0787 8.39935 14.0787 8.79558 13.8145 9.05973ZM5.95602 5.29558C5.95602 5.09746 5.88998 4.96539 5.7579 4.83331C5.69186 4.76728 5.62583 4.70124 5.55979 4.70124C5.29564 4.56916 5.03149 4.6352 4.83337 4.83331C4.7013 4.96539 4.63526 5.09746 4.63526 5.29558C4.63526 5.36162 4.63526 5.49369 4.7013 5.55973C4.7013 5.62577 4.76734 5.6918 4.83337 5.75784C4.96545 5.88992 5.09752 5.95596 5.29564 5.95596C5.49375 5.95596 5.62583 5.88992 5.7579 5.75784C5.88998 5.62577 5.95602 5.49369 5.95602 5.29558Z",
      fill: "currentColor",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_2559_94071",
      maskUnits: "userSpaceOnUse",
      x: "4",
      y: "4",
      width: "2",
      height: "2",
      e2eid: "Icons_index_mask",
      children: /*#__PURE__*/_jsx("path", {
        d: "M5.7579 4.83336C5.88997 4.96543 5.95601 5.09751 5.95601 5.29562C5.95601 5.49374 5.88997 5.62581 5.7579 5.75789C5.62582 5.88996 5.49374 5.956 5.29563 5.956C5.09752 5.956 4.96544 5.88996 4.83337 5.75789C4.76733 5.69185 4.70129 5.62581 4.70129 5.55977C4.63525 5.49374 4.63525 5.36166 4.63525 5.29562C4.63525 5.09751 4.70129 4.96543 4.83337 4.83336C5.03148 4.63524 5.29563 4.56921 5.55978 4.70128C5.62582 4.70128 5.69186 4.76732 5.7579 4.83336Z",
        fill: "currentColor",
        e2eid: "Icons_index_path"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_2559_94071)",
      e2eid: "Icons_index_g"
    })]
  }));
};
export var ResetIcon = function ResetIcon(_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === void 0 ? '#A2A2A2' : _ref5$color,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "26",
    height: "26",
    viewBox: "0 0 26 26",
    fill: "none"
  }, rest), {}, {
    color: color,
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M17.5186 23.1823C16.3214 23.6163 15.1241 23.8333 13.9268 23.8333C9.46421 23.8333 5.21931 21.012 3.6955 16.5629C3.47781 16.0204 3.80434 15.3693 4.34856 15.1523C4.89278 14.9352 5.54584 15.2608 5.76353 15.8033C7.39618 20.3609 12.2942 22.7482 16.8656 21.1205C21.437 19.4928 23.8316 14.6097 22.1989 10.0521C21.437 7.88185 19.8044 6.14564 17.7363 5.0605C15.6683 4.08388 13.2737 3.97537 11.0969 4.73496C9.89959 5.16901 8.70231 5.8201 7.83156 6.79672L4.67509 9.72658H8.48462C9.13768 9.72658 9.57306 10.1606 9.57306 10.8117C9.57306 11.4628 9.13768 11.8969 8.48462 11.8969H1.954C1.84516 11.8969 1.73631 11.8969 1.73631 11.8969H1.62747L1.51863 11.7883C1.40978 11.7883 1.40978 11.6798 1.30094 11.6798C1.30094 11.6798 1.30094 11.5713 1.1921 11.5713C1.1921 11.4628 1.08325 11.4628 1.08325 11.3543C1.08325 11.2458 1.08325 11.1373 1.08325 11.1373V11.0287V4.30091C1.08325 3.64983 1.51863 3.21577 2.17169 3.21577C2.82475 3.21577 3.26013 3.64983 3.26013 4.30091V8.31591L6.52544 5.27753C7.61387 4.19239 9.02884 3.32428 10.5527 2.78172C13.2737 1.8051 16.2125 2.02212 18.8248 3.21577C21.437 4.51793 23.3962 6.6882 24.3758 9.40104C26.2261 15.0437 23.1785 21.229 17.5186 23.1823Z",
      fill: "#0C0B0B",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_27482_7729",
      maskUnits: "userSpaceOnUse",
      x: "1",
      y: "2",
      width: "24",
      height: "22",
      e2eid: "Icons_index_mask",
      children: /*#__PURE__*/_jsx("path", {
        d: "M17.5186 23.1823C16.3214 23.6163 15.1241 23.8333 13.9268 23.8333C9.46421 23.8333 5.21931 21.012 3.6955 16.5629C3.47781 16.0204 3.80434 15.3693 4.34856 15.1523C4.89278 14.9352 5.54584 15.2608 5.76353 15.8033C7.39618 20.3609 12.2942 22.7482 16.8656 21.1205C21.437 19.4928 23.8316 14.6097 22.1989 10.0521C21.437 7.88185 19.8044 6.14564 17.7363 5.0605C15.6683 4.08388 13.2737 3.97537 11.0969 4.73496C9.89959 5.16901 8.70231 5.8201 7.83156 6.79672L4.67509 9.72658H8.48462C9.13768 9.72658 9.57306 10.1606 9.57306 10.8117C9.57306 11.4628 9.13768 11.8969 8.48462 11.8969H1.954C1.84516 11.8969 1.73631 11.8969 1.73631 11.8969H1.62747L1.51863 11.7883C1.40978 11.7883 1.40978 11.6798 1.30094 11.6798C1.30094 11.6798 1.30094 11.5713 1.1921 11.5713C1.1921 11.4628 1.08325 11.4628 1.08325 11.3543C1.08325 11.2458 1.08325 11.1373 1.08325 11.1373V11.0287V4.30091C1.08325 3.64983 1.51863 3.21577 2.17169 3.21577C2.82475 3.21577 3.26013 3.64983 3.26013 4.30091V8.31591L6.52544 5.27753C7.61387 4.19239 9.02884 3.32428 10.5527 2.78172C13.2737 1.8051 16.2125 2.02212 18.8248 3.21577C21.437 4.51793 23.3962 6.6882 24.3758 9.40104C26.2261 15.0437 23.1785 21.229 17.5186 23.1823Z",
        fill: "white",
        e2eid: "Icons_index_path"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_27482_7729)",
      e2eid: "Icons_index_g",
      children: /*#__PURE__*/_jsx("rect", {
        width: "26",
        height: "26",
        fill: "#5E5873",
        e2eid: "Icons_index_rect"
      })
    })]
  }));
};
export var ZoomOutIcon = function ZoomOutIcon(_ref6) {
  var _ref6$color = _ref6.color,
      color = _ref6$color === void 0 ? '#A2A2A2' : _ref6$color,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "26",
    height: "26",
    viewBox: "0 0 26 26",
    fill: "none"
  }, rest), {}, {
    color: color,
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.5084 21.9917L19.5001 17.9833C20.8001 16.3583 21.6667 14.1917 21.6667 11.9167C21.6667 6.50001 17.3334 2.16667 11.9167 2.16667C6.50008 2.16667 2.16675 6.50001 2.16675 11.9167C2.16675 17.3333 6.50008 21.6667 11.9167 21.6667C14.1917 21.6667 16.3584 20.9083 17.9834 19.5L21.9917 23.5083C22.2084 23.725 22.5334 23.8333 22.7501 23.8333C22.9667 23.8333 23.2917 23.725 23.5084 23.5083C23.9417 23.075 23.9417 22.425 23.5084 21.9917ZM4.33341 11.9167C4.33341 7.69167 7.69175 4.33334 11.9167 4.33334C16.1417 4.33334 19.5001 7.69167 19.5001 11.9167C19.5001 13.975 18.6334 15.925 17.3334 17.225C15.9251 18.6333 14.0834 19.3917 12.0251 19.3917C7.69175 19.5 4.33341 16.1417 4.33341 11.9167ZM15.1667 13C15.8167 13 16.2501 12.5667 16.2501 11.9167C16.2501 11.2667 15.8167 10.8333 15.1667 10.8333H8.66675C8.01675 10.8333 7.58341 11.2667 7.58341 11.9167C7.58341 12.5667 8.01675 13 8.66675 13H15.1667Z",
      fill: "#0C0B0B",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_27482_7716",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "2",
      width: "22",
      height: "22",
      e2eid: "Icons_index_mask",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.5084 21.9917L19.5001 17.9833C20.8001 16.3583 21.6667 14.1917 21.6667 11.9167C21.6667 6.50001 17.3334 2.16667 11.9167 2.16667C6.50008 2.16667 2.16675 6.50001 2.16675 11.9167C2.16675 17.3333 6.50008 21.6667 11.9167 21.6667C14.1917 21.6667 16.3584 20.9083 17.9834 19.5L21.9917 23.5083C22.2084 23.725 22.5334 23.8333 22.7501 23.8333C22.9667 23.8333 23.2917 23.725 23.5084 23.5083C23.9417 23.075 23.9417 22.425 23.5084 21.9917ZM4.33341 11.9167C4.33341 7.69167 7.69175 4.33334 11.9167 4.33334C16.1417 4.33334 19.5001 7.69167 19.5001 11.9167C19.5001 13.975 18.6334 15.925 17.3334 17.225C15.9251 18.6333 14.0834 19.3917 12.0251 19.3917C7.69175 19.5 4.33341 16.1417 4.33341 11.9167ZM15.1667 13C15.8167 13 16.2501 12.5667 16.2501 11.9167C16.2501 11.2667 15.8167 10.8333 15.1667 10.8333H8.66675C8.01675 10.8333 7.58341 11.2667 7.58341 11.9167C7.58341 12.5667 8.01675 13 8.66675 13H15.1667Z",
        fill: "white",
        e2eid: "Icons_index_path"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_27482_7716)",
      e2eid: "Icons_index_g",
      children: /*#__PURE__*/_jsx("rect", {
        width: "26",
        height: "26",
        fill: "#5E5873",
        e2eid: "Icons_index_rect"
      })
    })]
  }));
};
export var ZoomInIcon = function ZoomInIcon(_ref7) {
  var _ref7$color = _ref7.color,
      color = _ref7$color === void 0 ? '#A2A2A2' : _ref7$color,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "26",
    height: "26",
    viewBox: "0 0 26 26",
    fill: "none"
  }, rest), {}, {
    color: color,
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.5084 21.9917L19.5001 17.9833C20.8001 16.3583 21.6667 14.1917 21.6667 11.9167C21.6667 6.5 17.3334 2.16666 11.9167 2.16666C6.50008 2.16666 2.16675 6.5 2.16675 11.9167C2.16675 17.3333 6.50008 21.6667 11.9167 21.6667C14.1917 21.6667 16.3584 20.9083 17.9834 19.5L21.9917 23.5083C22.2084 23.725 22.5334 23.8333 22.7501 23.8333C22.9667 23.8333 23.2917 23.725 23.5084 23.5083C23.9417 23.075 23.9417 22.425 23.5084 21.9917ZM4.33341 11.9167C4.33341 7.69166 7.69175 4.33333 11.9167 4.33333C16.1417 4.33333 19.5001 7.69166 19.5001 11.9167C19.5001 13.975 18.6334 15.925 17.3334 17.225C15.9251 18.6333 14.0834 19.3917 12.0251 19.3917C7.69175 19.5 4.33341 16.1417 4.33341 11.9167ZM15.1667 13C15.8167 13 16.2501 12.5667 16.2501 11.9167C16.2501 11.2667 15.8167 10.8333 15.1667 10.8333H13.0001V8.66666C13.0001 8.01666 12.5667 7.58333 11.9167 7.58333C11.2667 7.58333 10.8334 8.01666 10.8334 8.66666V10.8333H8.66675C8.01675 10.8333 7.58341 11.2667 7.58341 11.9167C7.58341 12.5667 8.01675 13 8.66675 13H10.8334V15.1667C10.8334 15.8167 11.2667 16.25 11.9167 16.25C12.5667 16.25 13.0001 15.8167 13.0001 15.1667V13H15.1667Z",
      fill: "#0C0B0B",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_27482_7703",
      maskUnits: "userSpaceOnUse",
      x: "2",
      y: "2",
      width: "22",
      height: "22",
      e2eid: "Icons_index_mask",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.5084 21.9917L19.5001 17.9833C20.8001 16.3583 21.6667 14.1917 21.6667 11.9167C21.6667 6.5 17.3334 2.16666 11.9167 2.16666C6.50008 2.16666 2.16675 6.5 2.16675 11.9167C2.16675 17.3333 6.50008 21.6667 11.9167 21.6667C14.1917 21.6667 16.3584 20.9083 17.9834 19.5L21.9917 23.5083C22.2084 23.725 22.5334 23.8333 22.7501 23.8333C22.9667 23.8333 23.2917 23.725 23.5084 23.5083C23.9417 23.075 23.9417 22.425 23.5084 21.9917ZM4.33341 11.9167C4.33341 7.69166 7.69175 4.33333 11.9167 4.33333C16.1417 4.33333 19.5001 7.69166 19.5001 11.9167C19.5001 13.975 18.6334 15.925 17.3334 17.225C15.9251 18.6333 14.0834 19.3917 12.0251 19.3917C7.69175 19.5 4.33341 16.1417 4.33341 11.9167ZM15.1667 13C15.8167 13 16.2501 12.5667 16.2501 11.9167C16.2501 11.2667 15.8167 10.8333 15.1667 10.8333H13.0001V8.66666C13.0001 8.01666 12.5667 7.58333 11.9167 7.58333C11.2667 7.58333 10.8334 8.01666 10.8334 8.66666V10.8333H8.66675C8.01675 10.8333 7.58341 11.2667 7.58341 11.9167C7.58341 12.5667 8.01675 13 8.66675 13H10.8334V15.1667C10.8334 15.8167 11.2667 16.25 11.9167 16.25C12.5667 16.25 13.0001 15.8167 13.0001 15.1667V13H15.1667Z",
        fill: "white",
        e2eid: "Icons_index_path"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_27482_7703)",
      e2eid: "Icons_index_g",
      children: /*#__PURE__*/_jsx("rect", {
        width: "26",
        height: "26",
        fill: "#5E5873",
        e2eid: "Icons_index_rect"
      })
    })]
  }));
};
export var EyeIcon = function EyeIcon(_ref8) {
  var _ref8$color = _ref8.color,
      color = _ref8$color === void 0 ? '#A2A2A2' : _ref8$color,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none"
  }, rest), {}, {
    color: color,
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 3.00555C16.263 3.00555 19.7704 9.83382 19.9374 10.1669C20.0209 10.3334 20.0209 10.6665 19.9374 10.8331C19.7704 11.1662 16.263 17.9944 10 17.9944C4.10489 17.9944 0.651244 11.9449 0.126531 11.0258C0.0937818 10.9684 0.0724421 10.931 0.0626305 10.9164C-0.0208768 10.6665 -0.0208768 10.4167 0.0626305 10.1669C0.229645 9.83382 3.73695 3.00555 10 3.00555ZM1.73278 10.5C2.56785 11.8323 5.49061 16.329 10 16.329C14.5094 16.329 17.4321 11.8323 18.2672 10.5C17.4321 9.16765 14.5094 4.67098 10 4.67098C5.49061 4.67098 2.48434 9.16765 1.73278 10.5ZM10 7.16913C8.16284 7.16913 6.65971 8.66802 6.65971 10.5C6.65971 12.332 8.16284 13.8309 10 13.8309C11.8372 13.8309 13.3403 12.332 13.3403 10.5C13.3403 8.66802 11.8372 7.16913 10 7.16913ZM8.32985 10.5C8.32985 11.416 9.08142 12.1654 10 12.1654C10.9186 12.1654 11.6701 11.416 11.6701 10.5C11.6701 9.584 10.9186 8.83456 10 8.83456C9.08142 8.83456 8.32985 9.584 8.32985 10.5Z",
      fill: "currentColor",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_27463_1829",
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "20",
      height: "15",
      e2eid: "Icons_index_mask",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 3.00555C16.263 3.00555 19.7704 9.83382 19.9374 10.1669C20.0209 10.3334 20.0209 10.6665 19.9374 10.8331C19.7704 11.1662 16.263 17.9944 10 17.9944C4.10489 17.9944 0.651244 11.9449 0.126531 11.0258C0.0937818 10.9684 0.0724421 10.931 0.0626305 10.9164C-0.0208768 10.6665 -0.0208768 10.4167 0.0626305 10.1669C0.229645 9.83382 3.73695 3.00555 10 3.00555ZM1.73278 10.5C2.56785 11.8323 5.49061 16.329 10 16.329C14.5094 16.329 17.4321 11.8323 18.2672 10.5C17.4321 9.16765 14.5094 4.67098 10 4.67098C5.49061 4.67098 2.48434 9.16765 1.73278 10.5ZM10 7.16913C8.16284 7.16913 6.65971 8.66802 6.65971 10.5C6.65971 12.332 8.16284 13.8309 10 13.8309C11.8372 13.8309 13.3403 12.332 13.3403 10.5C13.3403 8.66802 11.8372 7.16913 10 7.16913ZM8.32985 10.5C8.32985 11.416 9.08142 12.1654 10 12.1654C10.9186 12.1654 11.6701 11.416 11.6701 10.5C11.6701 9.584 10.9186 8.83456 10 8.83456C9.08142 8.83456 8.32985 9.584 8.32985 10.5Z",
        fill: "white",
        e2eid: "Icons_index_path"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_27463_1829)",
      e2eid: "Icons_index_g",
      children: /*#__PURE__*/_jsx("rect", {
        y: "0.507401",
        width: "20",
        height: "19.9852",
        fill: "currentColor",
        e2eid: "Icons_index_rect"
      })
    })]
  }));
};
export var DragIcon = function DragIcon(_ref9) {
  var _ref9$color = _ref9.color,
      color = _ref9$color === void 0 ? '#A2A2A2' : _ref9$color,
      rest = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, rest), {}, {
    viewBox: "0 0 16 16",
    fill: "none",
    color: color,
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.42891 4.41995C6.16225 4.41995 6.76225 3.82039 6.76225 3.0876C6.76225 2.35481 6.16225 1.75525 5.42891 1.75525C4.69558 1.75525 4.09558 2.35481 4.09558 3.0876C4.09558 3.82039 4.69558 4.41995 5.42891 4.41995ZM6.76225 7.75082C6.76225 8.48361 6.16225 9.08317 5.42891 9.08317C4.69558 9.08317 4.09558 8.48361 4.09558 7.75082C4.09558 7.01803 4.69558 6.41847 5.42891 6.41847C6.16225 6.41847 6.76225 7.01803 6.76225 7.75082ZM4.09558 12.414C4.09558 11.6813 4.69558 11.0817 5.42891 11.0817C6.16225 11.0817 6.76225 11.6813 6.76225 12.414C6.76225 13.1468 6.16225 13.7464 5.42891 13.7464C4.69558 13.7464 4.09558 13.1468 4.09558 12.414Z",
      fill: "currentColor",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.4359 4.41995C11.1692 4.41995 11.7692 3.82039 11.7692 3.0876C11.7692 2.35481 11.1692 1.75525 10.4359 1.75525C9.70254 1.75525 9.10254 2.35481 9.10254 3.0876C9.10254 3.82039 9.70254 4.41995 10.4359 4.41995ZM11.7692 7.75082C11.7692 8.48361 11.1692 9.08317 10.4359 9.08317C9.70254 9.08317 9.10254 8.48361 9.10254 7.75082C9.10254 7.01803 9.70254 6.41847 10.4359 6.41847C11.1692 6.41847 11.7692 7.01803 11.7692 7.75082ZM9.10254 12.414C9.10254 11.6813 9.70254 11.0817 10.4359 11.0817C11.1692 11.0817 11.7692 11.6813 11.7692 12.414C11.7692 13.1468 11.1692 13.7464 10.4359 13.7464C9.70254 13.7464 9.10254 13.1468 9.10254 12.414Z",
      fill: "currentColor",
      e2eid: "Icons_index_path_49"
    })]
  }));
};
export var ResetPriceIcon = function ResetPriceIcon(_ref10) {
  var _ref10$color = _ref10.color,
      color = _ref10$color === void 0 ? '#A2A2A2' : _ref10$color,
      rest = _objectWithoutProperties(_ref10, _excluded10);

  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "18",
    height: "16",
    viewBox: "0 0 18 16",
    color: color
  }, rest), {}, {
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.47451 7.61158H5.59624V4.684H7.93831C8.28962 4.684 8.52382 4.44979 8.52382 4.09848C8.52382 3.74717 8.28962 3.51296 7.93831 3.51296H5.59624V1.75641C5.59624 1.40511 5.36203 1.1709 5.01072 1.1709C4.65941 1.1709 4.42521 1.40511 4.42521 1.75641V3.51296H3.54693C2.08314 3.51296 0.912109 4.684 0.912109 6.14779C0.912109 7.61158 2.08314 8.78261 3.54693 8.78261H4.42521V11.7102H1.49763C1.14632 11.7102 0.912109 11.9444 0.912109 12.2957C0.912109 12.647 1.14632 12.8812 1.49763 12.8812H4.42521V14.6378C4.42521 14.9891 4.65941 15.2233 5.01072 15.2233C5.36203 15.2233 5.59624 14.9891 5.59624 14.6378V12.8812H6.47451C7.93831 12.8812 9.10934 11.7102 9.10934 10.2464C9.10934 8.78261 7.93831 7.61158 6.47451 7.61158ZM3.54694 7.61158C2.72722 7.61158 2.08315 6.96751 2.08315 6.14779C2.08315 5.32806 2.72722 4.684 3.54694 4.684H4.42521V7.61158H3.54694ZM5.59622 11.7102H6.4745C7.29422 11.7102 7.93829 11.0661 7.93829 10.2464C7.93829 9.42668 7.29422 8.78262 6.4745 8.78262H5.59622V11.7102Z",
      fill: "#5E5873",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.5501 14.1696C15.4889 14.1696 17.0606 11.6531 17.0606 8.54869C17.0606 5.44432 15.4889 2.92773 13.5501 2.92773C11.6113 2.92773 10.0396 5.44432 10.0396 8.54869C10.0396 11.6531 11.6113 14.1696 13.5501 14.1696ZM13.55 12.7644C14.7133 12.7644 15.6564 10.877 15.6564 8.54869C15.6564 6.22041 14.7133 4.33297 13.55 4.33297C12.3868 4.33297 11.4437 6.22041 11.4437 8.54869C11.4437 10.877 12.3868 12.7644 13.55 12.7644Z",
      fill: "#5E5873",
      e2eid: "Icons_index_path_52"
    })]
  }));
};
export var PinIcon = function PinIcon(_ref11) {
  var color = _ref11.color,
      rest = _objectWithoutProperties(_ref11, _excluded11);

  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({}, rest), {}, {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    color: color,
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("rect", {
      width: "18",
      height: "18",
      rx: "9",
      fill: "white",
      e2eid: "Icons_index_rect"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "9",
      cy: "9",
      r: "8",
      fill: "currentColor",
      e2eid: "Icons_index_circle"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.5677 7.71349C13.5262 7.54709 13.4016 7.4639 13.2355 7.4223L10.5779 7.0479L9.37368 4.63514C9.24911 4.34395 8.75081 4.34395 8.62623 4.63514L7.42201 7.0063L4.80592 7.4223C4.63982 7.4223 4.51525 7.54709 4.4322 7.71349C4.39067 7.87989 4.4322 8.04629 4.55677 8.12948L6.46693 10.0015L6.01015 12.6638C5.96863 12.8302 6.05168 12.9966 6.17625 13.0798C6.30083 13.163 6.46693 13.2046 6.63303 13.1214L8.99996 11.8734L11.3669 13.1214C11.4499 13.1214 11.4915 13.1214 11.5745 13.1214C11.6576 13.1214 11.7406 13.0798 11.8237 13.0382C11.9482 12.955 12.0313 12.7886 11.9898 12.6222L11.533 9.95985L13.4431 8.08788C13.5677 8.00469 13.6092 7.83829 13.5677 7.71349Z",
      fill: "white",
      e2eid: "Icons_index_path"
    })]
  }));
};
export var EqualIcon = function EqualIcon(_ref12) {
  var color = _ref12.color,
      rest = _objectWithoutProperties(_ref12, _excluded12);

  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "29",
    height: "29",
    viewBox: "0 0 29 29",
    fill: "none",
    color: color
  }, rest), {}, {
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M23.9239 10.9755C23.9239 11.6587 23.4681 12.1141 22.7844 12.1141H6.83231C6.14865 12.1141 5.69287 11.6587 5.69287 10.9755C5.69287 10.2924 6.14865 9.83691 6.83231 9.83691H22.7844C23.4681 9.83691 23.9239 10.2924 23.9239 10.9755Z",
      fill: "#A2A2A2",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("path", {
      d: "M23.9239 18.2526C23.9239 18.9358 23.4681 19.3912 22.7844 19.3912H6.83231C6.14865 19.3912 5.69287 18.9358 5.69287 18.2526C5.69287 17.5695 6.14865 17.114 6.83231 17.114H22.7844C23.4681 17.114 23.9239 17.5695 23.9239 18.2526Z",
      fill: "#A2A2A2",
      e2eid: "Icons_index_path_59"
    })]
  }));
};
export var DetailsIcon = function DetailsIcon(_ref13) {
  var _ref13$color = _ref13.color,
      color = _ref13$color === void 0 ? '#A2A2A2' : _ref13$color,
      rest = _objectWithoutProperties(_ref13, _excluded13);

  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    color: color
  }, rest), {}, {
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.6268 11.8477C13.6427 11.8158 13.6586 11.784 13.6905 11.7521C13.7542 11.6885 13.7542 11.5611 13.7542 11.4975L13.7542 3.85664C13.7542 2.77419 12.9259 1.94644 11.8428 1.94644L4.19708 1.94644C3.11393 1.94644 2.28565 2.77419 2.28565 3.85664L2.28564 14.0444C2.28564 15.1268 3.11393 15.9546 4.19707 15.9546L9.29422 15.9546C9.35793 15.9546 9.48536 15.9546 9.54907 15.8909C9.61279 15.8909 9.6765 15.8272 9.74022 15.7636L13.5631 11.9432C13.5949 11.9113 13.6109 11.8795 13.6268 11.8477ZM11.5879 12.1342L9.93135 13.7897L9.93135 12.1342L11.5879 12.1342ZM11.8427 3.21991L4.19703 3.21991C3.81474 3.21991 3.55989 3.4746 3.55989 3.85664L3.55989 14.0444C3.55989 14.4264 3.81474 14.6811 4.19703 14.6811L8.65703 14.6811L8.65703 11.4975C8.65703 11.1154 8.91189 10.8607 9.29417 10.8607L12.4799 10.8607L12.4799 3.85664C12.4799 3.4746 12.225 3.21991 11.8427 3.21991ZM10.5685 8.83279C10.9508 8.83279 11.2057 9.08749 11.2057 9.46953C11.2057 9.85157 10.9508 10.1063 10.5685 10.1063L5.47137 10.1063C5.08909 10.1063 4.83423 9.85157 4.83423 9.46953C4.83423 9.08749 5.08909 8.83279 5.47137 8.83279L10.5685 8.83279ZM11.2057 6.92259C11.2057 6.54055 10.9508 6.28585 10.5685 6.28585L5.47137 6.28585C5.08909 6.28585 4.83423 6.54055 4.83423 6.92259C4.83423 7.30463 5.08909 7.55932 5.47137 7.55932L10.5685 7.55932C10.9508 7.55932 11.2057 7.30463 11.2057 6.92259ZM5.47137 12.6532C5.08909 12.6532 4.83423 12.3985 4.83423 12.0165C4.83423 11.6344 5.08909 11.3797 5.47137 11.3797L6.74566 11.3797C7.12795 11.3797 7.3828 11.6344 7.3828 12.0165C7.3828 12.3985 7.12795 12.6532 6.74566 12.6532L5.47137 12.6532Z",
      fill: "#5E5873",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.52001 2.30127C4.46763 2.27507 4.43569 2.21777 4.43569 2.14239L4.43569 1.61869C4.43569 1.04262 4.85193 0.571289 5.36067 0.571289C5.8694 0.571289 6.28564 1.04262 6.28564 1.61869L6.28564 1.87353C6.28564 1.97827 6.22398 2.0481 6.13148 2.0481C6.03898 2.0481 5.97732 1.97827 5.97732 1.87353L5.97732 1.61869C5.97732 1.23464 5.69983 0.920423 5.36067 0.920423C5.02151 0.920423 4.74401 1.23464 4.74401 1.61869L4.74401 2.14239C4.74401 2.21777 4.71208 2.27507 4.65969 2.30127C4.71208 2.32747 4.74401 2.38476 4.74401 2.46014L4.74401 4.1267C4.74401 4.51075 5.02151 4.82497 5.36067 4.82497C5.69982 4.82497 5.97732 4.59586 5.97732 4.21181L5.97732 4.19446C5.97732 4.08972 6.03898 4.01989 6.13148 4.01989C6.2175 4.01989 6.27685 4.08027 6.28475 4.17296C6.26318 4.72779 5.85572 5.1741 5.36067 5.1741C4.85193 5.1741 4.43569 4.70277 4.43569 4.1267L4.43569 2.46014C4.43569 2.38476 4.46763 2.32746 4.52001 2.30127ZM6.28475 4.17296C6.28534 4.17995 6.28564 4.18712 6.28564 4.19446L6.28564 4.1267C6.28564 4.1422 6.28534 4.15762 6.28475 4.17296Z",
      fill: "#0C0B0B",
      e2eid: "Icons_index_path_62"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.52001 2.30127L4.74366 2.74846L5.63782 2.30127L4.74367 1.85408L4.52001 2.30127ZM4.65969 2.30127L4.43604 1.85407L3.54188 2.30126L4.43604 2.74846L4.65969 2.30127ZM5.97732 4.21181L5.47732 4.21181L5.97732 4.21181ZM5.97732 4.19446L6.47732 4.19446L5.97732 4.19446ZM4.74367 1.85408C4.90068 1.9326 4.93569 2.07774 4.93569 2.14239L3.93569 2.14239C3.93569 2.3578 4.03457 2.61753 4.29636 2.74846L4.74367 1.85408ZM4.93569 2.14239L4.93569 1.61869L3.93569 1.61869L3.93569 2.14239L4.93569 2.14239ZM4.93569 1.61869C4.93569 1.25854 5.18467 1.07129 5.36067 1.07129L5.36067 0.071289C4.51919 0.071289 3.93569 0.826694 3.93569 1.61869L4.93569 1.61869ZM5.36067 1.07129C5.53667 1.07129 5.78564 1.25854 5.78564 1.61869L6.78564 1.61869C6.78564 0.826695 6.20214 0.0712891 5.36067 0.071289L5.36067 1.07129ZM5.78564 1.61869L5.78564 1.87353L6.78564 1.87353L6.78564 1.61869L5.78564 1.61869ZM5.78564 1.87353C5.78564 1.82953 5.79933 1.74742 5.86847 1.66912C5.94258 1.5852 6.04395 1.5481 6.13148 1.5481L6.13148 2.5481C6.31151 2.5481 6.48996 2.47608 6.61803 2.33106C6.74113 2.19167 6.78564 2.02227 6.78564 1.87353L5.78564 1.87353ZM6.13148 1.5481C6.21901 1.5481 6.32038 1.5852 6.39449 1.66912C6.46364 1.74742 6.47732 1.82953 6.47732 1.87353L5.47732 1.87353C5.47732 2.02227 5.52183 2.19167 5.64494 2.33106C5.773 2.47608 5.95145 2.5481 6.13148 2.5481L6.13148 1.5481ZM6.47732 1.87353L6.47732 1.61869L5.47732 1.61869L5.47732 1.87353L6.47732 1.87353ZM6.47732 1.61869C6.47732 1.01872 6.03256 0.420423 5.36067 0.420423L5.36067 1.42042C5.3693 1.42042 5.39226 1.42352 5.4214 1.45651C5.45117 1.49022 5.47732 1.54658 5.47732 1.61869L6.47732 1.61869ZM5.36067 0.420423C4.68877 0.420423 4.24401 1.01872 4.24401 1.61869L5.24401 1.61869C5.24401 1.54658 5.27016 1.49022 5.29993 1.45651C5.32907 1.42352 5.35203 1.42042 5.36067 1.42042L5.36067 0.420423ZM4.24401 1.61869L4.24401 2.14239L5.24401 2.14239L5.24401 1.61869L4.24401 1.61869ZM4.24401 2.14239C4.24401 2.07774 4.27902 1.9326 4.43604 1.85407L4.88334 2.74846C5.14513 2.61753 5.24401 2.3578 5.24401 2.14239L4.24401 2.14239ZM5.24401 2.46014C5.24401 2.24473 5.14513 1.985 4.88334 1.85408L4.43604 2.74846C4.27902 2.66993 4.24401 2.52479 4.24401 2.46014L5.24401 2.46014ZM5.24401 4.1267L5.24401 2.46014L4.24401 2.46014L4.24401 4.1267L5.24401 4.1267ZM5.36067 4.32497C5.35203 4.32497 5.32907 4.32187 5.29993 4.28888C5.27016 4.25517 5.24401 4.19881 5.24401 4.1267L4.24401 4.1267C4.24401 4.72667 4.68877 5.32497 5.36067 5.32497L5.36067 4.32497ZM5.47732 4.21181C5.47732 4.24702 5.47112 4.2677 5.46682 4.27805C5.4626 4.28824 5.4579 4.29416 5.45334 4.29845C5.44497 4.30634 5.4182 4.32497 5.36067 4.32497L5.36067 5.32497C5.64229 5.32497 5.92385 5.22904 6.13901 5.02636C6.35857 4.81955 6.47732 4.531 6.47732 4.21181L5.47732 4.21181ZM5.47732 4.19446L5.47732 4.21181L6.47732 4.21181L6.47732 4.19446L5.47732 4.19446ZM6.13148 3.51989C5.95145 3.51989 5.773 3.59191 5.64494 3.73692C5.52183 3.87632 5.47732 4.04571 5.47732 4.19446L6.47732 4.19446C6.47732 4.23846 6.46364 4.32057 6.39449 4.39887C6.32038 4.48278 6.21901 4.51989 6.13148 4.51989L6.13148 3.51989ZM6.78294 4.13053C6.77083 3.98834 6.71519 3.83283 6.59166 3.70881C6.46455 3.5812 6.29762 3.51989 6.13148 3.51989L6.13148 4.51989C6.05136 4.51989 5.95711 4.48877 5.88316 4.41452C5.81279 4.34387 5.79077 4.2649 5.78655 4.2154L6.78294 4.13053ZM5.36067 5.6741C6.179 5.6741 6.75463 4.95736 6.78437 4.19239L5.78512 4.15354C5.77172 4.49823 5.53243 4.6741 5.36067 4.6741L5.36067 5.6741ZM3.93569 4.1267C3.93569 4.9187 4.51919 5.6741 5.36067 5.6741L5.36067 4.6741C5.18467 4.6741 4.93569 4.48684 4.93569 4.1267L3.93569 4.1267ZM3.93569 2.46014L3.93569 4.1267L4.93569 4.1267L4.93569 2.46014L3.93569 2.46014ZM4.29636 1.85407C4.03457 1.985 3.93569 2.24473 3.93569 2.46014L4.93569 2.46014C4.93569 2.52479 4.90068 2.66993 4.74366 2.74846L4.29636 1.85407ZM6.78564 4.19446C6.78564 4.17337 6.78477 4.15204 6.78294 4.13053L5.78655 4.2154C5.78591 4.20786 5.78564 4.20086 5.78564 4.19446L6.78564 4.19446ZM5.78564 4.1267L5.78564 4.19446L6.78564 4.19446L6.78564 4.1267L5.78564 4.1267ZM6.78437 4.19239C6.78522 4.17058 6.78564 4.14868 6.78564 4.1267L5.78564 4.1267C5.78564 4.13572 5.78547 4.14467 5.78512 4.15354L6.78437 4.19239Z",
      fill: "#5E5873",
      e2eid: "Icons_index_path_63"
    })]
  }));
};
export var DotIcon = function DotIcon(_ref14) {
  var color = _ref14.color,
      rest = _objectWithoutProperties(_ref14, _excluded14);

  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, rest), {}, {
    viewBox: "0 0 200 200",
    color: color,
    e2eid: "Icons_index_Icon",
    children: /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0",
      e2eid: "Icons_index_path"
    })
  }));
};
export var DownloadIcon = function DownloadIcon() {
  return /*#__PURE__*/_jsxs(Icon, {
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.6333 15.4916C10.5416 15.4916 10.4499 15.4 10.3583 15.3083L6.69159 11.6416C6.32492 11.275 6.32492 10.725 6.69159 10.3583C7.05825 9.99163 7.60825 9.99163 7.97492 10.3583L10.0833 12.4666V1.83329C10.0833 1.28329 10.4499 0.916626 10.9999 0.916626C11.5499 0.916626 11.9166 1.28329 11.9166 1.83329V12.4666L14.0249 10.3583C14.3916 9.99163 14.9416 9.99163 15.3083 10.3583C15.6749 10.725 15.6749 11.275 15.3083 11.6416L11.6416 15.3083C11.5958 15.3541 11.5499 15.377 11.5041 15.4C11.4583 15.4229 11.4124 15.4458 11.3666 15.4916C11.2749 15.5833 11.0916 15.5833 10.9999 15.5833C10.9083 15.5833 10.7249 15.5833 10.6333 15.4916ZM20.1666 18.3333V15.5833C20.1666 15.0333 19.7999 14.6666 19.2499 14.6666C18.6999 14.6666 18.3333 15.0333 18.3333 15.5833V18.3333C18.3333 18.8833 17.9666 19.25 17.4166 19.25H4.58325C4.03325 19.25 3.66659 18.8833 3.66659 18.3333V15.5833C3.66659 15.0333 3.29992 14.6666 2.74992 14.6666C2.19992 14.6666 1.83325 15.0333 1.83325 15.5833V18.3333C1.83325 19.8916 3.02492 21.0833 4.58325 21.0833H17.4166C18.9749 21.0833 20.1666 19.8916 20.1666 18.3333Z",
      fill: "#0C0B0B",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_1128_3445",
      maskUnits: "userSpaceOnUse",
      x: "1",
      y: "0",
      width: "20",
      height: "22",
      e2eid: "Icons_index_mask",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.6333 15.4916C10.5416 15.4916 10.4499 15.4 10.3583 15.3083L6.69159 11.6416C6.32492 11.275 6.32492 10.725 6.69159 10.3583C7.05825 9.99163 7.60825 9.99163 7.97492 10.3583L10.0833 12.4666V1.83329C10.0833 1.28329 10.4499 0.916626 10.9999 0.916626C11.5499 0.916626 11.9166 1.28329 11.9166 1.83329V12.4666L14.0249 10.3583C14.3916 9.99163 14.9416 9.99163 15.3083 10.3583C15.6749 10.725 15.6749 11.275 15.3083 11.6416L11.6416 15.3083C11.5958 15.3541 11.5499 15.377 11.5041 15.4C11.4583 15.4229 11.4124 15.4458 11.3666 15.4916C11.2749 15.5833 11.0916 15.5833 10.9999 15.5833C10.9083 15.5833 10.7249 15.5833 10.6333 15.4916ZM20.1666 18.3333V15.5833C20.1666 15.0333 19.7999 14.6666 19.2499 14.6666C18.6999 14.6666 18.3333 15.0333 18.3333 15.5833V18.3333C18.3333 18.8833 17.9666 19.25 17.4166 19.25H4.58325C4.03325 19.25 3.66659 18.8833 3.66659 18.3333V15.5833C3.66659 15.0333 3.29992 14.6666 2.74992 14.6666C2.19992 14.6666 1.83325 15.0333 1.83325 15.5833V18.3333C1.83325 19.8916 3.02492 21.0833 4.58325 21.0833H17.4166C18.9749 21.0833 20.1666 19.8916 20.1666 18.3333Z",
        fill: "white",
        e2eid: "Icons_index_path"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_1128_3445)",
      e2eid: "Icons_index_g",
      children: /*#__PURE__*/_jsx("rect", {
        width: "22",
        height: "22",
        fill: "#5E5873",
        e2eid: "Icons_index_rect"
      })
    })]
  });
};
export var ArchiveIcon = function ArchiveIcon() {
  return /*#__PURE__*/_jsxs(Icon, {
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.916667 1.83337H21.0833C21.5896 1.83337 22 2.24378 22 2.75004V7.33337C22 7.83963 21.5896 8.25004 21.0833 8.25004H20.1667V7.33337C20.1667 6.82711 19.7563 6.41671 19.25 6.41671H20.1667V3.66671H1.83333V6.41671H2.75C2.24374 6.41671 1.83333 6.82711 1.83333 7.33337V8.25004H0.916667C0.410406 8.25004 0 7.83963 0 7.33337V2.75004C0 2.24378 0.410406 1.83337 0.916667 1.83337ZM3.66667 8.25004H1.83333V19.25C1.83333 19.7563 2.24374 20.1667 2.75 20.1667H19.25C19.7563 20.1667 20.1667 19.7563 20.1667 19.25V8.25004H18.3333V7.33337C18.3333 6.82711 18.7437 6.41671 19.25 6.41671H2.75C3.25626 6.41671 3.66667 6.82711 3.66667 7.33337V8.25004ZM3.66667 8.25004H18.3333V18.3334H3.66667V8.25004ZM8.25 11C8.25 11.5063 8.66041 11.9167 9.16667 11.9167H12.8333C13.3396 11.9167 13.75 11.5063 13.75 11C13.75 10.4938 13.3396 10.0834 12.8333 10.0834H9.16667C8.66041 10.0834 8.25 10.4938 8.25 11Z",
      fill: "#0C0B0B",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_27780_4142" // style="mask-type:luminance"
      ,
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "1",
      width: "22",
      height: "20",
      e2eid: "Icons_index_mask",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.916667 1.83337H21.0833C21.5896 1.83337 22 2.24378 22 2.75004V7.33337C22 7.83963 21.5896 8.25004 21.0833 8.25004H20.1667V7.33337C20.1667 6.82711 19.7563 6.41671 19.25 6.41671H20.1667V3.66671H1.83333V6.41671H2.75C2.24374 6.41671 1.83333 6.82711 1.83333 7.33337V8.25004H0.916667C0.410406 8.25004 0 7.83963 0 7.33337V2.75004C0 2.24378 0.410406 1.83337 0.916667 1.83337ZM3.66667 8.25004H1.83333V19.25C1.83333 19.7563 2.24374 20.1667 2.75 20.1667H19.25C19.7563 20.1667 20.1667 19.7563 20.1667 19.25V8.25004H18.3333V7.33337C18.3333 6.82711 18.7437 6.41671 19.25 6.41671H2.75C3.25626 6.41671 3.66667 6.82711 3.66667 7.33337V8.25004ZM3.66667 8.25004H18.3333V18.3334H3.66667V8.25004ZM8.25 11C8.25 11.5063 8.66041 11.9167 9.16667 11.9167H12.8333C13.3396 11.9167 13.75 11.5063 13.75 11C13.75 10.4938 13.3396 10.0834 12.8333 10.0834H9.16667C8.66041 10.0834 8.25 10.4938 8.25 11Z",
        fill: "white",
        e2eid: "Icons_index_path"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask0_27780_4142)",
      e2eid: "Icons_index_g",
      children: [/*#__PURE__*/_jsx("rect", {
        width: "22",
        height: "22",
        fill: "#5E5873",
        e2eid: "Icons_index_rect"
      }), /*#__PURE__*/_jsx("rect", {
        width: "22",
        height: "22",
        fill: "#5E5873",
        e2eid: "Icons_index_rect_78"
      })]
    })]
  });
};
export var UnArchiveIcon = function UnArchiveIcon() {
  return /*#__PURE__*/_jsx(Icon, {
    width: 22,
    height: 22,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    e2eid: "Icons_index_Icon",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.930406 15.1283L21.3996 0.657777C21.9134 0.294511 22.6242 0.41628 22.9872 0.929756L26.2736 5.57841C26.6366 6.09189 26.5143 6.80263 26.0004 7.1659L9.55773 18.79V16.0013L23.7555 5.9643L21.7837 3.1751L3.17534 16.3301L5.14715 19.1193L7.27886 17.6123V20.401L5.53129 21.6364C5.01743 21.9997 4.3066 21.8779 3.9436 21.3645L0.657259 16.7158C0.294259 16.2023 0.416551 15.4916 0.930406 15.1283ZM7.27886 17.6123V15.1088C7.27886 14.4799 7.789 13.9702 8.4183 13.9702C9.04759 13.9702 9.55773 14.4799 9.55773 15.1088V16.0013L7.27886 17.6123ZM7.27886 20.401L9.55773 18.79V28.7719H27.7887V15.1088C27.7887 14.4799 28.2988 13.9702 28.9281 13.9702C29.5574 13.9702 30.0676 14.4799 30.0676 15.1088V29.9105C30.0676 30.5394 29.5574 31.0491 28.9281 31.0491H8.4183C7.789 31.0491 7.27886 30.5394 7.27886 29.9105V20.401ZM15.2549 19.6632C15.2549 20.292 15.765 20.8018 16.3943 20.8018H20.9521C21.5814 20.8018 22.0915 20.292 22.0915 19.6632C22.0915 19.0343 21.5814 18.5246 20.9521 18.5246H16.3943C15.765 18.5246 15.2549 19.0343 15.2549 19.6632Z",
      fill: "#5E5873",
      e2eid: "Icons_index_path"
    })
  });
};
export var VideoIcon = function VideoIcon(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "23",
    height: "15",
    viewBox: "0 0 23 15",
    fill: "none"
  }, props), {}, {
    e2eid: "Icons_index_Icon",
    children: /*#__PURE__*/_jsx("path", {
      d: "M22.2094 2.00968C21.93 1.82357 21.5575 1.91662 21.2781 2.10274L16.1563 5.73193V2.84719C16.1563 1.26523 14.9456 0.0554962 13.3625 0.0554962H3.11876C1.53564 0.0554962 0.325012 1.26523 0.325012 2.84719V12.1528C0.325012 13.7348 1.53564 14.9445 3.11876 14.9445H13.3625C14.9456 14.9445 16.1563 13.7348 16.1563 12.1528V9.26807L21.185 12.8973C21.3713 12.9903 21.5575 13.0834 21.7438 13.0834C21.93 13.0834 22.0231 13.0834 22.2094 12.9903C22.4888 12.8042 22.675 12.525 22.675 12.1528V2.84719C22.675 2.47496 22.4888 2.19579 22.2094 2.00968Z",
      e2eid: "Icons_index_path"
    })
  }));
};
export var TurnsIntoToVideoIcon = function TurnsIntoToVideoIcon(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "23",
    viewBox: "0 0 34 23",
    fill: "none"
  }, props), {}, {
    e2eid: "Icons_index_Icon",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M31.108 5.75824C31.3705 5.58324 31.7205 5.49574 31.983 5.67074C32.2455 5.84574 32.4205 6.10824 32.4205 6.45824V15.2082C32.4205 15.5582 32.2455 15.8207 31.983 15.9957C31.808 16.0832 31.7205 16.0832 31.5455 16.0832C31.3705 16.0832 31.1955 15.9957 31.0205 15.9082L26.2955 12.4957V15.2082C26.2955 16.6957 25.158 17.8332 23.6705 17.8332H14.0455C12.558 17.8332 11.4205 16.6957 11.4205 15.2082V6.45824C11.4205 4.97074 12.558 3.83324 14.0455 3.83324H23.6705C25.158 3.83324 26.2955 4.97074 26.2955 6.45824V9.17074L31.108 5.75824ZM10.3078 12.1403L5.69337 15.959C5.63777 16.0021 5.56854 16.0314 5.49368 16.0434C5.41883 16.0553 5.34141 16.0495 5.27038 16.0266C5.2004 16.0022 5.14069 15.9613 5.09877 15.9089C5.05686 15.8565 5.03462 15.7951 5.03486 15.7322V14.1411H1.18954C0.985567 14.1411 0.789953 14.0741 0.645725 13.9547C0.501498 13.8354 0.420471 13.6735 0.420471 13.5047V10.3225C0.420471 10.1537 0.501498 9.99181 0.645725 9.87245C0.789953 9.7531 0.985567 9.68604 1.18954 9.68604H5.03486V8.09494C5.03462 8.03212 5.05686 7.97064 5.09877 7.91826C5.14069 7.86588 5.2004 7.82493 5.27038 7.80059C5.34141 7.77766 5.41883 7.77185 5.49368 7.78381C5.56854 7.79578 5.63777 7.82504 5.69337 7.86821L10.3078 11.6869C10.38 11.7472 10.4205 11.8287 10.4205 11.9136C10.4205 11.9985 10.38 12.08 10.3078 12.1403Z",
      e2eid: "Icons_index_path"
    })
  }));
};
export var Edit2Icon = function Edit2Icon(props) {
  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "18",
    height: "19",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.025 5.35142L9.525 12.8514C9.375 13.0014 9.225 13.0764 9 13.0764H6C5.55 13.0764 5.25 12.7764 5.25 12.3264V9.32642C5.25 9.10142 5.325 8.95142 5.475 8.80142L12.975 1.30142C13.275 1.00142 13.725 1.00142 14.025 1.30142L17.025 4.30142C17.325 4.60142 17.325 5.05142 17.025 5.35142ZM15.75 11.3514V15.3264C15.75 16.6014 14.775 17.5764 13.5 17.5764H3C1.725 17.5764 0.75 16.6014 0.75 15.3264V4.82642C0.75 3.55142 1.725 2.57642 3 2.57642H6.975C7.425 2.57642 7.725 2.87642 7.725 3.32642C7.725 3.77642 7.425 4.07642 6.975 4.07642H3C2.55 4.07642 2.25 4.37642 2.25 4.82642V15.3264C2.25 15.7764 2.55 16.0764 3 16.0764H13.5C13.95 16.0764 14.25 15.7764 14.25 15.3264V11.3514C14.25 10.9014 14.55 10.6014 15 10.6014C15.45 10.6014 15.75 10.9014 15.75 11.3514ZM13.5 2.87642L15.45 4.82642L8.7 11.5764H6.75V9.62642L13.5 2.87642Z",
      fill: "#A2A2A2",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_27206_13050" // style="mask-type:luminance"
      ,
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "1",
      width: "18",
      height: "17",
      e2eid: "Icons_index_mask",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.025 5.35142L9.525 12.8514C9.375 13.0014 9.225 13.0764 9 13.0764H6C5.55 13.0764 5.25 12.7764 5.25 12.3264V9.32642C5.25 9.10142 5.325 8.95142 5.475 8.80142L12.975 1.30142C13.275 1.00142 13.725 1.00142 14.025 1.30142L17.025 4.30142C17.325 4.60142 17.325 5.05142 17.025 5.35142ZM15.75 11.3514V15.3264C15.75 16.6014 14.775 17.5764 13.5 17.5764H3C1.725 17.5764 0.75 16.6014 0.75 15.3264V4.82642C0.75 3.55142 1.725 2.57642 3 2.57642H6.975C7.425 2.57642 7.725 2.87642 7.725 3.32642C7.725 3.77642 7.425 4.07642 6.975 4.07642H3C2.55 4.07642 2.25 4.37642 2.25 4.82642V15.3264C2.25 15.7764 2.55 16.0764 3 16.0764H13.5C13.95 16.0764 14.25 15.7764 14.25 15.3264V11.3514C14.25 10.9014 14.55 10.6014 15 10.6014C15.45 10.6014 15.75 10.9014 15.75 11.3514ZM13.5 2.87642L15.45 4.82642L8.7 11.5764H6.75V9.62642L13.5 2.87642Z",
        fill: "white",
        e2eid: "Icons_index_path"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_27206_13050)",
      e2eid: "Icons_index_g",
      children: /*#__PURE__*/_jsx("rect", {
        y: "0.326416",
        width: "18",
        height: "18",
        fill: "#A2A2A2",
        e2eid: "Icons_index_rect"
      })
    })]
  }));
};
export var TrashIcon = function TrashIcon(props) {
  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "18",
    height: "19",
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.75 4.07372H12.75V3.32427C12.75 2.05021 11.775 1.07593 10.5 1.07593H7.5C6.225 1.07593 5.25 2.05021 5.25 3.32427V4.07372H2.25C1.8 4.07372 1.5 4.3735 1.5 4.82317C1.5 5.27283 1.8 5.57261 2.25 5.57261H3V15.3154C3 16.5895 3.975 17.5638 5.25 17.5638H12.75C14.025 17.5638 15 16.5895 15 15.3154V5.57261H15.75C16.2 5.57261 16.5 5.27283 16.5 4.82317C16.5 4.3735 16.2 4.07372 15.75 4.07372ZM6.75 3.32427C6.75 2.8746 7.05 2.57482 7.5 2.57482H10.5C10.95 2.57482 11.25 2.8746 11.25 3.32427V4.07372H6.75V3.32427ZM12.75 16.0649C13.2 16.0649 13.5 15.7651 13.5 15.3154V5.57261H4.5V15.3154C4.5 15.7651 4.8 16.0649 5.25 16.0649H12.75ZM8.25 8.5704V13.0671C8.25 13.5168 7.95 13.8165 7.5 13.8165C7.05 13.8165 6.75 13.5168 6.75 13.0671V8.5704C6.75 8.12073 7.05 7.82096 7.5 7.82096C7.95 7.82096 8.25 8.12073 8.25 8.5704ZM11.25 13.0671V8.5704C11.25 8.12073 10.95 7.82096 10.5 7.82096C10.05 7.82096 9.75 8.12073 9.75 8.5704V13.0671C9.75 13.5168 10.05 13.8165 10.5 13.8165C10.95 13.8165 11.25 13.5168 11.25 13.0671Z",
      fill: "currentColor",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_27206_13051",
      maskUnits: "userSpaceOnUse",
      x: "1",
      y: "1",
      width: "16",
      height: "17",
      e2eid: "Icons_index_mask",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.75 4.07372H12.75V3.32427C12.75 2.05021 11.775 1.07593 10.5 1.07593H7.5C6.225 1.07593 5.25 2.05021 5.25 3.32427V4.07372H2.25C1.8 4.07372 1.5 4.3735 1.5 4.82317C1.5 5.27283 1.8 5.57261 2.25 5.57261H3V15.3154C3 16.5895 3.975 17.5638 5.25 17.5638H12.75C14.025 17.5638 15 16.5895 15 15.3154V5.57261H15.75C16.2 5.57261 16.5 5.27283 16.5 4.82317C16.5 4.3735 16.2 4.07372 15.75 4.07372ZM6.75 3.32427C6.75 2.8746 7.05 2.57482 7.5 2.57482H10.5C10.95 2.57482 11.25 2.8746 11.25 3.32427V4.07372H6.75V3.32427ZM12.75 16.0649C13.2 16.0649 13.5 15.7651 13.5 15.3154V5.57261H4.5V15.3154C4.5 15.7651 4.8 16.0649 5.25 16.0649H12.75ZM8.25 8.5704V13.0671C8.25 13.5168 7.95 13.8165 7.5 13.8165C7.05 13.8165 6.75 13.5168 6.75 13.0671V8.5704C6.75 8.12073 7.05 7.82096 7.5 7.82096C7.95 7.82096 8.25 8.12073 8.25 8.5704ZM11.25 13.0671V8.5704C11.25 8.12073 10.95 7.82096 10.5 7.82096C10.05 7.82096 9.75 8.12073 9.75 8.5704V13.0671C9.75 13.5168 10.05 13.8165 10.5 13.8165C10.95 13.8165 11.25 13.5168 11.25 13.0671Z",
        fill: "white",
        e2eid: "Icons_index_path"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_27206_13051)",
      e2eid: "Icons_index_g",
      children: /*#__PURE__*/_jsx("rect", {
        y: "0.326416",
        width: "18",
        height: "17.9867",
        fill: "currentColor",
        e2eid: "Icons_index_rect"
      })
    })]
  }));
};
export var NotificationIcon = function NotificationIcon(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    e2eid: "Icons_index_Icon",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23 17C23 17.6 22.6 18 22 18H2C1.4 18 1 17.6 1 17C1 16.4 1.4 16 2 16C3.1 16 4 15.1 4 14V9C4 4.6 7.6 1 12 1C16.4 1 20 4.6 20 9V14C20 15.1 20.9 16 22 16C22.6 16 23 16.4 23 17ZM14.6 21.5C14 22.5 13 23 12 23C11.5 23 11 22.9 10.5 22.6C10 22.3 9.7 22 9.4 21.5C9.1 21 9.3 20.4 9.8 20.1C10.3 19.8 10.9 20 11.2 20.5C11.2303 20.5303 11.2605 20.5697 11.2936 20.6128L11.2936 20.6128C11.3697 20.7119 11.4606 20.8303 11.6 20.9C12.1 21.2 12.7 21 13 20.5C13.3 20 13.9 19.9 14.4 20.1C14.9 20.3 14.9 21 14.6 21.5ZM18 14C18 14.7 18.2 15.4 18.5 16H5.5C5.8 15.4 6 14.7 6 14V9C6 5.7 8.7 3 12 3C15.3 3 18 5.7 18 9V14Z",
      fill: "currentColor",
      e2eid: "Icons_index_path"
    })
  }));
};
export var CircleIcon = function CircleIcon(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({
    viewBox: "0 0 200 200"
  }, props), {}, {
    e2eid: "Icons_index_Icon",
    children: /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0",
      e2eid: "Icons_index_path"
    })
  }));
};
export var GridIcon = function GridIcon(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({
    width: "29",
    height: "28",
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    e2eid: "Icons_index_Icon",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.31967 2.61053H12.2957C12.9794 2.61053 13.4352 3.06597 13.4352 3.74913V11.7193C13.4352 12.4025 12.9794 12.8579 12.2957 12.8579H4.31967C3.63601 12.8579 3.18024 12.4025 3.18024 11.7193V3.74913C3.18024 3.06597 3.63601 2.61053 4.31967 2.61053ZM5.45911 10.5807H11.1563V4.88773H5.45911V10.5807ZM24.8295 2.61053H16.8535C16.1698 2.61053 15.714 3.06597 15.714 3.74913V11.7193C15.714 12.4025 16.1698 12.8579 16.8535 12.8579H24.8295C25.5132 12.8579 25.969 12.4025 25.969 11.7193V3.74913C25.969 3.06597 25.5132 2.61053 24.8295 2.61053ZM17.9929 10.5807H23.6901V4.88773H17.9929V10.5807ZM24.8295 15.1351H16.8535C16.1698 15.1351 15.714 15.5905 15.714 16.2737V24.2439C15.714 24.927 16.1698 25.3825 16.8535 25.3825H24.8295C25.5132 25.3825 25.969 24.927 25.969 24.2439V16.2737C25.969 15.5905 25.5132 15.1351 24.8295 15.1351ZM17.9929 23.1053H23.6901V17.4123H17.9929V23.1053ZM12.2957 15.1351H4.31967C3.63601 15.1351 3.18024 15.5905 3.18024 16.2737V24.2439C3.18024 24.927 3.63601 25.3825 4.31967 25.3825H12.2957C12.9794 25.3825 13.4352 24.927 13.4352 24.2439V16.2737C13.4352 15.5905 12.9794 15.1351 12.2957 15.1351ZM5.45911 23.1053H11.1563V17.4123H5.45911V23.1053Z",
      fill: "currentColor",
      e2eid: "Icons_index_path"
    })
  }));
};
export var RadioIcon = function RadioIcon(props) {
  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "29",
    height: "28",
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 17.2C17.7 17.5 17.5 17.9 17.5 18.4C17.5 19.2 18.4 19.6 19 19.2C20.8 17.9 22 15.7 22 13.3C22 8.90001 18.3 5.50001 13.8 6.00001C10.3 6.30001 7.49996 9.00001 7.19996 12.4C6.89996 15.2 8.09996 17.7 10.1 19.1C10.7 19.5 11.6 19.1 11.6 18.4C11.6 17.9 11.4 17.5 11.1 17.2C9.89996 16.1 9.19996 14.5 9.29996 12.7C9.49996 10.3 11.5 8.30001 14 8.00001C17.2 7.70001 19.8 10.1 19.8 13.2C19.8 14.8 19.1 16.3 18 17.2Z",
      fill: "currentColor",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 1.40001C8.29997 1.70001 3.39997 6.30001 3.09997 12.1C2.79997 17.3 5.79997 21.8 10.3 23.5C10.9 23.7 11.6 23.3 11.6 22.6C11.6 22.1 11.3 21.7 10.9 21.5C7.19997 19.9 4.69997 16.1 5.19997 11.6C5.69997 7.40001 9.19997 4.00001 13.4 3.60001C19.1 3.00001 23.8 7.40001 23.8 12.9C23.8 16.8 21.4 20.2 18 21.6C17.6 21.8 17.3 22.1 17.3 22.6C17.3 23.3 18 23.8 18.7 23.6C22.9 21.9 25.9 17.8 25.9 13C25.9 6.40001 20.6 1.20001 14 1.40001Z",
      fill: "currentColor",
      e2eid: "Icons_index_path_105"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.5 9.90001C12.6 9.90001 11.1 11.4 11.1 13.3C11.1 14.9 12.1 16.1 13.5 16.6V25.7C13.5 26.3 14 26.7 14.5 26.7C15.1 26.7 15.5 26.2 15.5 25.7V16.6C16.9 16.2 17.9 14.9 17.9 13.3C17.9 11.4 16.4 9.90001 14.5 9.90001ZM14.5 14.5C13.8 14.5 13.4 14 13.4 13.4C13.4 12.7 13.9 12.3 14.5 12.3C15.2 12.3 15.6 12.8 15.6 13.4C15.6 14 15.2 14.5 14.5 14.5Z",
      fill: "currentColor",
      e2eid: "Icons_index_path_106"
    })]
  }));
};
export var SendIcon = function SendIcon(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), {}, {
    e2eid: "Icons_index_Icon",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23 2.90735C23 2.80735 23 2.70735 22.9 2.60735V2.50735C22.9 2.40735 22.8 2.30735 22.7 2.20735C22.65 2.15735 22.6 2.13235 22.55 2.10735C22.5 2.08235 22.45 2.05735 22.4 2.00735H22.3C22.2 2.00735 22.1 2.00735 22 1.90735V2.00735C21.9 2.00735 21.8 2.00735 21.7 2.10735L1.7 9.10735C1.3 9.20735 1 9.50735 1 10.0073C1 10.4073 1.2 10.8073 1.6 11.0073L10.2 14.8073L14 23.4073C14.2 23.8073 14.5 24.0073 14.9 24.0073C15.3 24.0073 15.7 23.7073 15.8 23.3073L22.8 3.30735C23 3.20735 23 3.10735 23 2.90735ZM18.2 5.40735L10.8 12.8073L4.7 10.1073L18.2 5.40735ZM12.2 14.2073L14.9 20.3073L19.6 6.80735L12.2 14.2073Z",
      fill: "currentColor",
      e2eid: "Icons_index_path"
    })
  }));
};
export var LanguageIcon = function LanguageIcon(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    e2eid: "Icons_index_Icon",
    children: /*#__PURE__*/_jsx("path", {
      d: "M20.8638 12.6172C20.6977 12.1845 20.2822 11.8988 19.8187 11.8988C19.3552 11.8988 18.9396 12.1845 18.7736 12.6172L17.2438 16.6035C15.5956 16.2273 14.0423 15.5248 12.6788 14.5388C14.2712 12.8244 15.3317 10.6972 15.7351 8.40846H17.9746C18.2026 8.40846 18.4213 8.31931 18.5825 8.16063C18.7437 8.00194 18.8343 7.78672 18.8343 7.56231C18.8343 7.33789 18.7437 7.12267 18.5825 6.96399C18.4213 6.8053 18.2026 6.71615 17.9746 6.71615H12.279V4.84615C12.279 4.62174 12.1884 4.40652 12.0272 4.24783C11.866 4.08915 11.6473 4 11.4193 4C11.1913 4 10.9726 4.08915 10.8114 4.24783C10.6502 4.40652 10.5596 4.62174 10.5596 4.84615V6.71615H4.85971C4.6317 6.71615 4.41303 6.8053 4.2518 6.96399C4.09058 7.12267 4 7.33789 4 7.56231C4 7.78672 4.09058 8.00194 4.2518 8.16063C4.41303 8.31931 4.6317 8.40846 4.85971 8.40846H7.10356C7.50498 10.6969 8.56408 12.8243 10.1555 14.5388C8.68919 15.5957 7.00922 16.3301 5.22939 16.6923C5.00138 16.7164 4.79244 16.8287 4.64855 17.0045C4.50465 17.1802 4.43758 17.405 4.46209 17.6294C4.48661 17.8538 4.60069 18.0595 4.77925 18.2011C4.95781 18.3427 5.18621 18.4087 5.41422 18.3846C5.47796 18.3862 5.54161 18.3791 5.60336 18.3635C7.72365 17.9365 9.71444 17.0314 11.4193 15.7192C12.9574 16.9065 14.7349 17.7574 16.6335 18.2154L14.1747 24.6038C13.9157 25.2767 14.4124 26 15.1333 26C15.5687 26 15.9567 25.7256 16.1018 25.3152L17.0203 22.7169H22.5826L23.5098 25.3107C23.6575 25.7241 24.0492 26 24.4882 26C25.2171 26 25.7195 25.2691 25.4583 24.5886L20.8638 12.6172ZM14.0113 8.40846C13.6541 10.2885 12.7594 12.0291 11.4322 13.4262C10.104 12.0298 9.20914 10.2888 8.85307 8.40846H14.0113ZM17.7425 20.7412L19.8187 14.89L21.8777 20.7412H17.7425Z",
      fill: "currentColor",
      e2eid: "Icons_index_path"
    })
  }));
};
export var CopyIcon = function CopyIcon(props) {
  return /*#__PURE__*/_jsxs(Icon, _objectSpread(_objectSpread({
    width: "21",
    height: "22",
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    e2eid: "Icons_index_Icon",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.66668 14.3892C5.16668 14.3892 5.50001 14.0503 5.50001 13.5419C5.50001 13.0335 5.16668 12.6946 4.66668 12.6946H3.83334C3.33334 12.6946 3.00001 12.3557 3.00001 11.8473V4.22169C3.00001 3.71331 3.33334 3.3744 3.83334 3.3744H11.3333C11.8333 3.3744 12.1667 3.71331 12.1667 4.22169V5.06898C12.1667 5.57736 12.5 5.91627 13 5.91627C13.5 5.91627 13.8333 5.57736 13.8333 5.06898V4.22169C13.8333 2.78129 12.75 1.67981 11.3333 1.67981H3.83334C2.41668 1.67981 1.33334 2.78129 1.33334 4.22169V11.8473C1.33334 13.2877 2.41668 14.3892 3.83334 14.3892H4.66668ZM17.1667 7.61086H9.66668C8.25001 7.61086 7.16668 8.71234 7.16668 10.1527V17.7784C7.16668 19.2188 8.25001 20.3202 9.66668 20.3202H17.1667C18.5833 20.3202 19.6667 19.2188 19.6667 17.7784V10.1527C19.6667 8.71234 18.5833 7.61086 17.1667 7.61086ZM18 17.7784C18 18.2867 17.6667 18.6257 17.1667 18.6257H9.66668C9.16668 18.6257 8.83334 18.2867 8.83334 17.7784V10.1527C8.83334 9.64436 9.16668 9.30544 9.66668 9.30544H17.1667C17.6667 9.30544 18 9.64436 18 10.1527V17.7784Z",
      fill: "currentColor",
      e2eid: "Icons_index_path"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask0_1117_7433",
      maskUnits: "userSpaceOnUse",
      x: "1",
      y: "1",
      width: "19",
      height: "20",
      e2eid: "Icons_index_mask",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.66668 14.3892C5.16668 14.3892 5.50001 14.0503 5.50001 13.5419C5.50001 13.0335 5.16668 12.6946 4.66668 12.6946H3.83334C3.33334 12.6946 3.00001 12.3557 3.00001 11.8473V4.22169C3.00001 3.71331 3.33334 3.3744 3.83334 3.3744H11.3333C11.8333 3.3744 12.1667 3.71331 12.1667 4.22169V5.06898C12.1667 5.57736 12.5 5.91627 13 5.91627C13.5 5.91627 13.8333 5.57736 13.8333 5.06898V4.22169C13.8333 2.78129 12.75 1.67981 11.3333 1.67981H3.83334C2.41668 1.67981 1.33334 2.78129 1.33334 4.22169V11.8473C1.33334 13.2877 2.41668 14.3892 3.83334 14.3892H4.66668ZM17.1667 7.61086H9.66668C8.25001 7.61086 7.16668 8.71234 7.16668 10.1527V17.7784C7.16668 19.2188 8.25001 20.3202 9.66668 20.3202H17.1667C18.5833 20.3202 19.6667 19.2188 19.6667 17.7784V10.1527C19.6667 8.71234 18.5833 7.61086 17.1667 7.61086ZM18 17.7784C18 18.2867 17.6667 18.6257 17.1667 18.6257H9.66668C9.16668 18.6257 8.83334 18.2867 8.83334 17.7784V10.1527C8.83334 9.64436 9.16668 9.30544 9.66668 9.30544H17.1667C17.6667 9.30544 18 9.64436 18 10.1527V17.7784Z",
        fill: "white",
        e2eid: "Icons_index_path"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_1117_7433)",
      e2eid: "Icons_index_g",
      children: /*#__PURE__*/_jsx("rect", {
        x: "0.5",
        y: "0.83252",
        width: "20",
        height: "20.335",
        fill: "currentColor",
        e2eid: "Icons_index_rect"
      })
    })]
  }));
};